import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { AnalyzerDataSetting, CreateOrUpdateDataSettingDto } from 'types';

export const createAnalyzerDataSettings = ({
  data,
  analyzerId,
}: {
  data: CreateOrUpdateDataSettingDto;
  analyzerId: number;
}): Promise<AnalyzerDataSetting> => {
  return axios.post(`/api/analyzers/${analyzerId}/data-settings`, data);
};

type UseCreateAnalyzerDataSettingsOptions = {
  analyzerId?: number;
  config?: MutationConfig<typeof createAnalyzerDataSettings>;
};

export const useCreateAnalyzerDataSettings = ({
  config,
  analyzerId,
}: UseCreateAnalyzerDataSettingsOptions) => {
  return useMutation({
    onMutate: async (newTimeWarning) => {
      await queryClient.cancelQueries([
        'analyzers',
        analyzerId,
        'dataSettings',
      ]);

      const previousDataSettings =
        queryClient.getQueryData<AnalyzerDataSetting>([
          'analyzers',
          analyzerId,
          'dataSettings',
        ]);

      queryClient.setQueryData(
        ['analyzers', analyzerId, 'dataSettings'],
        newTimeWarning.data
      );

      return { previousDataSettings };
    },
    onError: (_, __, context: any) => {
      if (context?.previousDataSettings) {
        queryClient.setQueryData(
          ['analyzers', analyzerId, 'dataSettings'],
          context.previousDataSettings
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['analyzer', analyzerId]);
    },
    ...config,
    mutationFn: createAnalyzerDataSettings,
  });
};
